import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Text } from '@uhg-abyss/web/ui/Text';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';

export const FeedbackFormContainer = styled('div', {
  padding: '0 24px',
  '@media (max-width: 1248px)': {
    padding: 0,
  },
});

export const StyledDrawer = styled(Drawer, {
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    width: '408px',
    '@media (max-width: 464px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    '@media (max-width: 464px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

export const StyledTextInputArea = styled(TextInputArea, {
  width: '100%',

  '&::placeholder': {
    color: '#929496',
    fontFamily: '$primary',
  },
  '&.abyss-text-input-area-label': {
    fontWeight: 700,
    color: '$core.color.neutral.90',
  },
  '&.abyss-text-input-area-container-wrapper': {
    '.abyss-text-input-area': {
      height: '90px',
    },

    '.abyss-layout-group': {
      width: '100%',
    },
    '.abyss-text-input-area-character-count': {
      textAlign: 'right',
    },
  },
});

export const DrawerSubtitle = styled(Text, {
  fontWeight: '600',
  lineHeight: '20px',
  color: '$core.color.neutral.90',
});

export const EmailInputStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  border: `1px solid $searchBorderColor`,
  'abyss-text-input-left-add-on': {
    backgroundColor: '$core.color.neutral.0',
    borderRight: 0,
  },

  'abyss-text-input': {
    height: '40px',
  },
};

export const AdditionalFeedbackContainer = styled('div', {
  marginBottom: '110px',
  '@media (max-width: 425px)': {
    marginBottom: '134px',
  },
});

export const AdditionalFeedbackInstruction = styled('div', {
  marginBottom: '24px',
});
